export function formatNumber(num: number): string {
    if (num > 99 || num < -99) {
        return num?.toFixed(0);
    } else if (num > 9 || num < -9 || num < -0.9) {
        return num?.toFixed(1);
    } else {
        return num?.toFixed(2);
    }
}
